export enum SeoPageType {
  JobsRole = 'JobsRole',
  JobsCity = 'JobsCity',
  JobsRoleCity = 'JobsRoleCity',
  SalaryRoleCity = 'SalaryRoleCity',
}

export enum SeoPageMetaField {
  Title = 'title',
  Description = 'description',
  H1 = 'h1',
}

export type SeoPlaceholder = 'role' | 'city' | 'state' | 'count' | 'radius' | 'domain' | 'medianSalary';

export type SeoPlaceholderValues = Partial<Record<SeoPlaceholder, string | number | null | undefined>>;

export interface SeoPageMetaContent {
  title: string | null;
  description: string | null;
  h1: string | null;
}

export const SEO_PAGE_PLACEHOLDERS: Record<SeoPageType, SeoPlaceholder[]> = {
  [SeoPageType.JobsRole]: ['role', 'count', 'domain'],
  [SeoPageType.JobsRoleCity]: ['role', 'city', 'state', 'count', 'radius', 'domain'],
  [SeoPageType.JobsCity]: ['city', 'state', 'count', 'radius', 'domain'],
  [SeoPageType.SalaryRoleCity]: ['role', 'city', 'domain', 'medianSalary'],
};

export const SEO_PAGE_PATH_PATTERNS: Record<SeoPageType, { section: 'jobs' | 'gehalt'; slugCount: number }> = {
  [SeoPageType.JobsRole]: { section: 'jobs', slugCount: 1 },
  [SeoPageType.JobsRoleCity]: { section: 'jobs', slugCount: 2 },
  [SeoPageType.JobsCity]: { section: 'jobs', slugCount: 1 },
  [SeoPageType.SalaryRoleCity]: { section: 'gehalt', slugCount: 2 },
};

export const SEO_PAGE_META_MAX_LENGTHS: Record<SeoPageMetaField, number> = {
  [SeoPageMetaField.Title]: 120,
  [SeoPageMetaField.Description]: 320,
  [SeoPageMetaField.H1]: 150,
};

export const SEO_PAGE_META_EDITABLE_FIELDS = ['pageType', 'sourceDomain', 'path', 'title', 'description', 'h1'] as const;

export type SeoPageMetaEditableField = (typeof SEO_PAGE_META_EDITABLE_FIELDS)[number];

export type SeoPageMetaSnapshot = Partial<Record<SeoPageMetaEditableField, string | null>>;
